export function getEndOfDayTimestamp(timestamp) {
  const date = new Date(timestamp);
  date.setHours(23, 59, 59, 999); // Set hours, minutes, seconds, and milliseconds to the end of the day

  return date;
}

const InputMaxValue = ({ time, className }) => {
  let date = getEndOfDayTimestamp(time);

  // Extract the hour and minute components
  let hour = date.getHours();
  let minute = date.getMinutes();

  // Convert the hour and minute components to 2-digit format
  hour = hour.toString().padStart(2, "0");
  minute = minute.toString().padStart(2, "0");

  // Extract the day, month, and year components
  let day = date.toLocaleDateString("en-US", { day: "numeric" });
  let month = date.toLocaleDateString("en-US", { month: "short" });
  let year = date.toLocaleDateString("en-US", { year: "2-digit" });

  // Extract the weekday component
  let weekday = date.toLocaleDateString("en-US", { weekday: "short" });

  // Construct the formatted date string
  let formattedDate = weekday + ", " + day + " " + month + " " + year + ", ";

  return (
    <span className={`${className} max-value `}>
      {formattedDate}
      <strong>{hour + ":" + minute}</strong>
    </span>
  );
};

export default InputMaxValue;
